import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Barbell, CheckCircle } from "@phosphor-icons/react";
import LogSetButton from "./LogSetButton";
import { useAuth } from "@/contexts/AuthContext";
import { getUnit } from "@/lib/weight";
import { formatStoredWeight } from "@/components/app/WeightInput";

export default function QuickLogRow({ mv, program, dayIdx, blockId, blockType, athleteId }) {
  const { user } = useAuth();
  const userUnit = getUnit(user);
  const mvUnit = mv.weight_unit || userUnit;
  const [open, setOpen] = useState(false);
  return (
    <div className="flex items-center gap-3 p-3 rounded-xl border border-line bg-surface" data-testid={`quick-log-row-${mv.id}`}>
      <div className="h-10 w-10 rounded-lg bg-sage/70 grid place-items-center shrink-0">
        <Barbell size={18} className="text-moss" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="font-medium truncate">{mv.name}</div>
        <div className="text-[11px] text-ink-3 font-data truncate">
          {[mv.sets && `${mv.sets}×${mv.reps ?? "?"}`, mv.weight && `@ ${formatStoredWeight(mv.weight, mvUnit)}`, mv.rpe && `RPE ${mv.rpe}`]
            .filter(Boolean)
            .join(" · ") || "Log your effort"}
        </div>
      </div>
      <LogSetButton
        mv={mv}
        program={program}
        dayIdx={dayIdx}
        blockId={blockId}
        blockType={blockType}
        athleteId={athleteId}
        open={open}
        setOpen={setOpen}
        trigger={
          <Button className="shrink-0 rounded-lg h-10 px-4 bg-terracotta hover:bg-terracotta-hover text-white hover:text-white" data-testid={`quick-log-btn-${mv.id}`}>
            <CheckCircle size={14} className="mr-1.5" /> Log
          </Button>
        }
      />
    </div>
  );
}
